<template>
  <footer class="mt-auto border-t border-slate-200 bg-white">
    <div
      class="mx-auto grid max-w-7xl gap-10 px-4 py-12 sm:grid-cols-2 sm:px-6 lg:grid-cols-4 lg:px-8"
    >
      <div class="lg:col-span-2">
        <img
          class="h-6 w-auto"
          src="@/assets/logo.png"
          alt="SaurusRehv"
          width="2023"
          height="245"
        />
        <p class="mt-4 max-w-sm text-sm leading-relaxed text-slate-500">
          Rehvid, rehvitööd ning rehvide taastamine ja remont. Kogemus alates
          1991. aastast.
        </p>
      </div>

      <div>
        <h2 class="text-sm font-semibold text-ink">Kontakt</h2>
        <ul class="mt-4 space-y-3 text-sm text-slate-600">
          <li class="flex items-start gap-2.5">
            <svg
              class="mt-0.5 h-4 w-4 shrink-0 text-brand"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.75"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
              />
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z"
              />
            </svg>
            <span>Selli tn 3, 50113 Tartu</span>
          </li>
          <li class="flex items-start gap-2.5">
            <svg
              class="mt-0.5 h-4 w-4 shrink-0 text-brand"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.75"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75"
              />
            </svg>
            <a
              href="mailto:saurusrehv@gmail.com"
              class="transition-colors hover:text-brand-600"
              >saurusrehv@gmail.com</a
            >
          </li>
        </ul>
      </div>

      <div>
        <h2 class="text-sm font-semibold text-ink">Lehed</h2>
        <ul class="mt-4 space-y-3 text-sm text-slate-600">
          <li>
            <router-link to="/" class="transition-colors hover:text-brand-600"
              >Kodu</router-link
            >
          </li>
          <li>
            <router-link
              to="/rehvid"
              class="transition-colors hover:text-brand-600"
              >Rehvid</router-link
            >
          </li>
          <li>
            <router-link
              to="/veljed"
              class="transition-colors hover:text-brand-600"
              >Veljed</router-link
            >
          </li>
          <li>
            <router-link
              to="/contactus"
              class="transition-colors hover:text-brand-600"
              >Meist</router-link
            >
          </li>
        </ul>
      </div>
    </div>

    <div class="border-t border-slate-200">
      <p
        class="mx-auto max-w-7xl px-4 py-5 text-xs text-slate-500 sm:px-6 lg:px-8"
      >
        &copy; {{ year }} SaurusRehv. Kõik õigused kaitstud.
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
};
</script>
